import React from 'react'

const withNofollow = WrappedComponent => class WithNofollow extends React.PureComponent {
  static displayName = `${WrappedComponent.displayName}WithNofollow`

  render() {
    return <WrappedComponent {...this.props} rel="nofollow" />
  }
}
export default withNofollow
